import ProfileIcon from '../images/navbar/ProfileIcon';

export const navbarItem = {
    name: 'Профиль',
    createIcon: (props: any) => <ProfileIcon {...props} />,
};
